import React, { Component } from 'react';
import Modal from '@material-ui/core/Modal';
import moment from 'moment';
import styles from './UOAModalStyles';
import CircularProgress from '@material-ui/core/CircularProgress';
import momentz from 'moment-timezone';
import { is_weekend } from './getDate';
import halfAccess from './uoa.png';
import halfAccessMobile from './mobileuoa.png';
import ModalTopDetail from './components/ModalTopDetail';
import ModalTable from './components/ModalTable';
import { BaseURL } from '../../../constants';

class UOAModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: true,
      modalLoader: false,
      removeWeeks: true,
      onlyAtm: true,
      uoaModalData: [],
      hoverTabelSortLabel: '',
      modalDate: momentz
        .tz(new Date(), 'America/New_York')
        .format('YYYY-MM-DD'),
    };
  }

  checkStatus = (response) => {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    const error = new Error(`HTTP Error: ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
  };
  parseJSON = (response) => {
    if (response) return response.json();
  };

  calcRR = (putVsCall, strike, premium, itm) => {
    if (itm === 0) return null;
    if (putVsCall === 'C')
      return strike + premium / itm > 0 ? strike + premium / itm : null;
    if (putVsCall === 'P')
      return strike - premium / itm > 0 ? strike - premium / itm : null;
  };

  getModalDataofUOA = (symbol, date, removeWeeks, onlyAtm) => {
    this.setState({ modalLoader: true });

    fetch(
      `${BaseURL}/api/getUOAmodal?symbol=${symbol}&date=${date}&removeWeeks=${removeWeeks}&onlyAtm=${onlyAtm}`
    )
      .then(this.checkStatus)
      .then(this.parseJSON)
      .then((response) => {
        if (!response || response.error) {
          return;
        }
        const NewData = response.map((row) => {
          let volValue =
            row.volume === 0 || row.open_int === 0
              ? 0
              : parseFloat(row.volume / row.open_int).toFixed(2);
          let RRS;
          let dividedValue =
            !row.theo_ask || !row.itm_prob
              ? 0
              : parseFloat(row.theo_ask / row.itm_prob);
          let FixedStrike = parseFloat(row.strike);
          row.put_call === 'C'
            ? (RRS = FixedStrike + dividedValue)
            : (RRS = FixedStrike - dividedValue);
          let newRRS = RRS >= 0 ? parseFloat(RRS).toFixed(2) : 0;
          return { ...row, volValue: Number(volValue), RRS: Number(newRRS) };
        });
        const sortedData = NewData.sort(
          (a, b) => parseFloat(b.volume) - parseFloat(a.volume)
        );
        this.setState({ uoaModalData: [...sortedData], modalLoader: false });
      });
  };

  removeWeeks = () => {
    const tempState = !this.state.removeWeeks;
    this.setState({ removeWeeks: tempState });
    this.getModalDataofUOA(
      this.props.modalRowData.Symbol,
      this.props.date,
      tempState,
      this.state.onlyAtm
    );
  };
  onlyAtm = () => {
    const tempState = !this.state.onlyAtm;
    this.setState({ onlyAtm: tempState });
    this.getModalDataofUOA(
      this.props.modalRowData.Symbol,
      this.props.date,
      this.state.removeWeeks,
      tempState
    );
  };

  componentDidMount() {
    let datetoSend;
    datetoSend = moment(this.props.date).isSame(this.state.modalDate)
      ? is_weekend(this.props.date)
      : this.props.date;
    this.setState({ modalDate: datetoSend });
    // eslint-disable-next-line no-lone-blocks
    {
      (this.props.accessLevel === 'fullaccess' || this.props.accessLevel === 'halfaccess') &&
        this.getModalDataofUOA(
          this.props.modalRowData.Symbol,
          datetoSend,
          this.state.removeWeeks,
          this.state.onlyAtm
        );
    }
  }
  render() {
    const { isVolClicked, handleModalClose, isMobile, accessLevel } =
      this.props;
    const { orderBy, order } = this.state;

    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={isVolClicked}
          onClose={handleModalClose}
        >
          <div
            style={
              isMobile
                ? { ...styles.Modal, width: '90%' }
                : {
                    ...styles.Modal,
                    width: window.innerWidth < 1400 ? '65%' : '50%',
                  }
            }
          >
            <div onClick={handleModalClose} style={styles.crossIconMOdal}>
              X
            </div>

            <ModalTopDetail
              styles={styles}
              state={this.state}
              removeWeeks={this.removeWeeks}
              onlyAtm={this.onlyAtm}
            />

            {accessLevel === 'halfaccess' ? (
              <div style={styles.premiumdivUoa}>
                <div>
                  <img
                    height="100%"
                    width="100%"
                    src={isMobile ? halfAccessMobile : halfAccess}
                    alt=""
                  />
                </div>
              </div>
            ) : this.state.modalLoader ? (
              <div style={{ paddingTop: '120px', paddingLeft: '420px' }}>
                <CircularProgress
                  style={{ height: '1.6rem', width: '1.6rem' }}
                  size="1.6rem"
                  color="white"
                />
              </div>
            ) : (
              <div
                style={
                  isMobile
                    ? {
                        ...styles.boardModalTableContainer,
                        width: '90%',
                        overflow: 'auto',
                      }
                    : { ...styles.boardModalTableContainer }
                }
              >
                <ModalTable
                  styles={styles}
                  order={order}
                  orderBy={orderBy}
                  state={this.state}
                  setState={(data) => this.setState(data)}
                />
              </div>
            )}
          </div>
        </Modal>
      </div>
    );
  }
}
export default UOAModal;



// WEBPACK FOOTER //
// ./src/components/Modals/UOAModal/UOAModal.js